<template>
    <div class="order_wrapper">
        <div v-if="isMobileScreen" class="order__heading">
            <button class="order__heading_back_arrow" @click.prevent="clickBackArrow">
                <svg>
                    <use xlink:href="/icons/base.svg#back_arrow"></use>
                </svg>
            </button>
            <div class="order__heading_number">
                {{ numberOrder }}
            </div>
        </div>
        <div v-if="isMobileScreen" class="rest_list__header">
            <div class="rest_list__header_container">
                <order_list_header_item
                    v-for="item in ordersListHeader"
                    :key="'order_list_header_item' + item.id"
                    :item="item"
                    @select_item_header="selectItemHeader"
                />
            </div>
        </div>

        <div v-if="showOrderContent" class="order_content">
            <order_content_header
                v-if="isOrder && !isLoadFullInfo"
                :key="'order_content_header_' + activeOrderId"
            />
            <order_content
                :key="'order_content_' + activeOrderId"
                :isLoadFullInfo="isLoadFullInfo"
                :isOrder="isOrder"
            />
            <div v-if="isOrder && !isLoadStates && !isLoadFullInfo"
                 class="order_content__buttons">
                <action_button
                    v-for="item in activeOrderStates"
                    :key="'action_button_' + item.action"
                    :itemButton="item"
                />
            </div>
        </div>
        <div v-if="showWrapperContactPos" class="order_wrapper_contact_pos">
            <order_contact
                v-if="showOrderContact"
                :key="'order_contact_' + activeOrderId"
                :isLoadFullInfo="isLoadFullInfo"
                :isLoadLogs="isLoadLogs"
                :isOrder="isOrder"
            />
            <div v-if="isOrder && !isLoadStates && !isLoadFullInfo && showOrderContact && isMobileScreen"
                 class="order_content__buttons">
                <action_button
                    v-for="item in activeOrderStates"
                    :key="'action_button_' + item.action"
                    :itemButton="item"
                />
            </div>
            <order_pos
                v-if="showOrderPos"
                :key="'order_pos_'+ activeOrderId"
                :isLoadLogs="isLoadLogs"
                :isOrder="isOrder"
            />

            <div v-if="isOrder && !isLoadStates && !isLoadFullInfo && showOrderPos && isMobileScreen"
                 class="order_content__buttons">
                <action_button
                    v-for="item in activeOrderStates"
                    :key="'action_button_' + item.action"
                    :itemButton="item"
                />
            </div>
        </div>

    </div>

</template>

<script>

import order_content from "./content/OrderContent.vue";
import order_pos from "./pos/OrderPos.vue";
import order_contact from "./contact/OrderContact.vue";
import order_content_header from "./content/OrderContentHeader.vue";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../mixins/screenSize";
import order_list_header_item from "./OrderListHeaderItem.vue";
import action_button from "./content/ActionButton.vue";

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "order",
    props: {
        isLoadFullInfo: {
            type: Boolean,
            required: true,
        },
        isLoadLogs: {
            type: Boolean,
            required: true,
        },
        isOrder: {
            type: Boolean,
            required: true,
        },
        isLoadStates: {
            type: Boolean,
            required: true,
        }
    },
    mixins: [screenSize],
    components: {
        action_button,
        order_list_header_item,
        order_content_header,
        order_content,
        order_contact,
        order_pos,
    },
    emits: ['click_back_arrow'],
    data() {
        return {
            isErrorPos: false,
            isReadyOrder: true,
            ordersListHeader: [
                {id: 0, name: 'Загальне', isSelect: true},
                {id: 1, name: 'Доставка', isSelect: false},
                {id: 2, name: 'POS', isSelect: false},
            ],
            ordersHeaderItem: {id: 0, name: 'Загальне', isSelect: true},
        }
    },
    methods: {
        selectItemHeader(itemHeader) {
            this.ordersListHeader.forEach(item => item.isSelect = item === itemHeader);
            this.ordersHeaderItem = itemHeader;
        },
        clickBackArrow() {
            this.$emit('click_back_arrow');
        },
    },
    computed: {
        ...mOrders([
            'activeItemMenuOrders',
            'activeOrderFullInfo',
            'activeOrderStates',
            'activeOrderLogs'
        ]),
        activeOrderId() {
            if (this.activeItemMenuOrders && this.activeItemMenuOrders.id) {
                return this.activeItemMenuOrders.id;
            }
            return '';
        },
        numberOrder() {
            if (this.activeItemMenuOrders.order_code) {
                return this.activeItemMenuOrders.order_code;
            }
            return '';
        },
        showOrderContent() {
            if (!this.isMobileScreen || (this.isMobileScreen && this.ordersHeaderItem.id === 0)) {
                return true;
            }
            return false;
        },
        showOrderContact() {
            if (!this.isMobileScreen || (this.isMobileScreen && this.ordersHeaderItem.id === 1)) {
                return true;
            }
            return false;
        },
        showOrderPos() {
            if (!this.isMobileScreen || (this.isMobileScreen && this.ordersHeaderItem.id === 2)) {
                return true;
            }
            return false;
        },
        showWrapperContactPos() {
            if (!this.isMobileScreen || (this.isMobileScreen && (this.showOrderPos || this.showOrderContact))) {
                return true;
            }
            return false;
        }
    }
}
</script>
